var _rect, _path, _path2, _path3, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 15,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5955 24.0665C22.5955 24.5812 22.1767 25 21.662 25H13.0367V14.8811H16.7892C17.304 14.8811 17.7227 15.2999 17.7227 15.8146V19.3805H21.662C22.1767 19.3805 22.5955 19.7992 22.5955 20.3139V24.0665Z",
    fill: "#9DB4DB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5955 24.0664C22.5955 24.5811 22.1767 24.9999 21.662 24.9999H17.7227V19.3804H21.662C22.1767 19.3804 22.5955 19.7991 22.5955 20.3138V24.0664Z",
    fill: "#B3C8EB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3362 10.3333H9.50806C9.07728 10.3333 8.72681 10.6837 8.72681 11.1145V24.2187C8.72681 24.6495 9.07728 24.9999 9.50806 24.9999H13.1174V12.7655V11.1145C13.1174 10.6837 12.767 10.3333 12.3362 10.3333Z",
    fill: "#829FCE"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2650_30950)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.4915 5.6377V9.17328L15.1306 7.4055L10.4915 5.6377Z",
    fill: "#FF4343"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3611 5.43237H10.642V11.0001H10.3611V5.43237Z",
    fill: "#707E8E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.642 5.43237H10.3611V11H10.642V9.11588V5.69493V5.43237Z",
    fill: "#515A66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7088 5.08399C10.6551 5.03203 10.582 5 10.5014 5C10.3636 5 10.2478 5.09342 10.2135 5.22035C10.2068 5.2452 10.2031 5.27132 10.2031 5.29829C10.2031 5.46303 10.3367 5.59658 10.5014 5.59658C10.5242 5.59658 10.5463 5.59395 10.5676 5.58912C10.7005 5.55901 10.7997 5.44028 10.7997 5.29828C10.7997 5.21417 10.7648 5.13822 10.7088 5.08399Z",
    fill: "#515A66"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2650_30950"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6,
    fill: "white",
    transform: "translate(9.66675 5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar4);
export default __webpack_public_path__ + "static/media/star 4.6b1da8c7b8d1e37858f64f1239ad8b46.svg";
export { ForwardRef as ReactComponent };